import React, { useMemo } from 'react'
import { format } from 'date-fns'

import Avatar from '../reusablePreviewComponents/Avatar'
import PageName from '../reusablePreviewComponents/PageName'
import Icon from '../../../../components/Icon'
import FacebookSocialPostMedia from './FacebookSocialPostMedia'

import { renderTextWithEmoji } from '../../../helpers/other'

import { ReactComponent as LikeReactionIcon } from '../../../../assets/icons/facebook/facebook-social-post/likeReaction.svg'
import { ReactComponent as LikeButtonIcon } from '../../../../assets/icons/facebook/facebook-social-post/likeButton.svg'
import { ReactComponent as CommentIcon } from '../../../../assets/icons/facebook/facebook-social-post/comment.svg'
import { ReactComponent as ShareIcon } from '../../../../assets/icons/facebook/facebook-social-post/share.svg'
import { ReactComponent as EarthIcon } from '../../../../assets/icons/facebook/facebook-social-post/earth-icon.svg'
import { ReactComponent as ActionButton } from '../../../../assets/icons/three-dots-horisontal-Icon.svg'

import { AD_TEXT, FB_PAGE_CHOICE } from '../../../../forms/Facebook/AdForms/fields'

import useStyles from './styles'

const FacebookSocialPostPreview = ({ formattedPost }) => {
  const classes = useStyles()

  const {
    file_url: fileUrl,
    media_type: mediaType,
    reactions,
    shares,
    created_time: createdTime,
    message_tags: messageTags = []
  } = formattedPost
  const postText = formattedPost[AD_TEXT]

  const formattedDate = useMemo(() => format(new Date(createdTime), "dd MMMM 'at' HH:mm"), [createdTime])

  return (
    <div className={classes.facebookSocialPost}>
      <div className={classes.header}>
        <div className={classes.headerTop}>
          <div className={classes.headerTopLeft}>
            <Avatar pageId={formattedPost[FB_PAGE_CHOICE]} size={24} />
            <div className={classes.info}>
              <div className={classes.name}>
                <PageName formikValues={formattedPost} />
              </div>
              <div className={classes.postDate}>
                {formattedDate} •{' '}
                <Icon className={classes.earthIcon}>
                  <EarthIcon />
                </Icon>
              </div>
            </div>
          </div>
          <Icon className={classes.actionButton}>
            <ActionButton />
          </Icon>
        </div>
        <div className={classes.adText}>{renderTextWithEmoji(postText)}</div>
        {!!messageTags?.length && <div className={classes.messageTags}>{messageTags.map(item => item.name + ' ')}</div>}
      </div>
      {fileUrl && <FacebookSocialPostMedia fileUrl={fileUrl} mediaType={mediaType} />}
      <div className={classes.footer}>
        <div className={classes.footerTop}>
          <div className={classes.footerLeft}>
            {!!reactions && (
              <div className={classes.reactions}>
                <Icon className={classes.reactionIcon}>
                  <LikeReactionIcon />
                </Icon>
                <p className={classes.reactionNumber}>{reactions}</p>
              </div>
            )}
          </div>
          <div className={classes.footerRight}>{!!shares && <div className={classes.shares}>{shares} shares</div>}</div>
        </div>
        <div className={classes.footerBottom}>
          <div className={classes.footerButtons}>
            <div className={classes.footerButton}>
              <Icon className={classes.buttonIcon}>
                <LikeButtonIcon />
              </Icon>
              <span>Like</span>
            </div>
            <div className={classes.footerButton}>
              <Icon className={classes.buttonIcon}>
                <CommentIcon />
              </Icon>
              <span>Comment</span>
            </div>
            <div className={classes.footerButton}>
              <Icon className={classes.buttonIcon}>
                <ShareIcon />
              </Icon>
              <span>Share</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FacebookSocialPostPreview
